module.exports = __webpack_public_path__ + "fonts/righthand-hairlineitalicdash-personal.6bafe6ce.ttf";